import { FetchStatus } from '@neptune/shared/common-domain';

import { AppState } from 'state/types';

import { OrganizationLimitsState } from './reducer';

function getOrganizationLimits(state: any): OrganizationLimitsState {
  return state.organizationLimits;
}

export const getExpirationDate = (state: AppState): Date | undefined =>
  getOrganizationLimits(state).expirationDate;
export const getLimitsFetchStatus = (state: AppState): FetchStatus =>
  getOrganizationLimits(state).fetchStatus;
export const getMembersLimit = (state: AppState): number | undefined =>
  getOrganizationLimits(state).membersLimit;
export const getProjectsLimit = (state: AppState): number | undefined =>
  getOrganizationLimits(state).projectsLimit;
export const getStorageLimit = (state: AppState): number | undefined =>
  getOrganizationLimits(state).storageSize;
